// Hooks
import { useAlbumContext } from '@/utils/hooks/context/useAlbumContext';

// Lib
import {
    ALBUM_AUTOMATIC_STEP,
    ALBUM_MANUAL_STEP,
    ALBUM_TYPE_STEP
} from '@/lib/albums/albumFunnel/steps';

import { AutomaticStep } from '@/components/pages/albums/AlbumFunnelModal/ModalSteps/AutomaticStep';
import { ManualStep } from '@/components/pages/albums/AlbumFunnelModal/ModalSteps/ManualStep';
// Components
import { SelectTypeStep } from '@/components/pages/albums/AlbumFunnelModal/ModalSteps/SelectTypeStep';

export const ModalSteps = (props) => {
    const { albumInfo } = useAlbumContext();
    switch (albumInfo?.currentStep) {
        case ALBUM_MANUAL_STEP:
            return <ManualStep {...props} />;
        case ALBUM_AUTOMATIC_STEP:
            return <AutomaticStep {...props} />;
        case ALBUM_TYPE_STEP:
        default:
            return <SelectTypeStep {...props} />;
    }
};
